export default (rating: number): number => {
    let ratingColorNumber = 0;

    const fixedRatingrating = +rating.toFixed(1);

    if (fixedRatingrating >= 4.5) {
        ratingColorNumber = 5;
    } else if (fixedRatingrating >= 4) {
        ratingColorNumber = 4;
    } else if (fixedRatingrating >= 3.5) {
        ratingColorNumber = 3;
    }

    return ratingColorNumber;
};
